import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';
import { CreateOutputsComponent } from 'src/app/components/home/output-assets/actions/create-outputs/create-outputs.component';

@Component({
  selector: 'app-create-outputs-icon-action',
  templateUrl: './create-outputs-icon-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class CreateOutputsIconActionComponent {
  @Input() product!: IProduct;
  @Input() selectedPostAssetIds: string[] = [];

  Permission = Permission;

  constructor(
    public authService: AuthService,
    private dialog: MatDialog,
  ) {}

  onGenerate(): void {
    this.dialog.open(CreateOutputsComponent, {
      data: {
        organizationId: this.product.organizationId,
        batchId: this.product.batchId,
        isBatch: false,
        productIds: this.product.id != null ? [this.product.id] : [],
        postAssetIds: this.selectedPostAssetIds,
      },
    });
  }
}
